
import React, { useEffect, useState } from 'react';
import { FaBell, FaUser, FaSignOutAlt, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import { NavLink, Routes, Route, Navigate } from 'react-router-dom';

import NotificationPanelContainer from './NotificationPanelContainer';

import ProfileUpdateForm from './ProfileUpdateForm';
import './PublicPage.css';

import { logoutPublicUser } from '../api/logoutApi';


import { useNavigate } from 'react-router-dom';


const PublicPage = () => {
  const navigate = useNavigate();
  // Get logged-in user's email and role from JWT
  let userEmail = '';
  let userRole = '';
  try {
    const token = localStorage.getItem('token');
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      userEmail = payload.email || '';
      userRole = payload.role || '';
    }
  } catch (e) {}

  // Redirect to login if not user role
  React.useEffect(() => {
    if (userRole !== 'user') {
      navigate('/publicuser/login', { replace: true });
    }
  }, [userRole, navigate]);

  // Sync with dark mode from Navbar
  useEffect(() => {
    const syncTheme = () => {
      if (document.body.classList.contains('dark-mode')) {
        document.documentElement.setAttribute('data-theme', 'dark');
      } else {
        document.documentElement.setAttribute('data-theme', 'light');
      }
    };
    syncTheme();
    window.addEventListener('darkModeChanged', syncTheme);
    return () => window.removeEventListener('darkModeChanged', syncTheme);
  }, []);

  const handleLogout = async () => {
    try {
      if (userEmail) {
        await logoutPublicUser(userEmail);
      }
    } catch (err) {
      // Optionally handle error (e.g., show notification)
    }
    localStorage.removeItem('token');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userMobile');
    window.dispatchEvent(new Event('tokenChanged'));
    navigate('/publicuser/login', {
      replace: true,
      state: { popupType: 'success', popupMessage: 'Logged out successfully' }
    });
  };

  // Sidebar collapse state (desktop only)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => window.innerWidth >= 700);
  useEffect(() => {
    // Collapse sidebar by default on desktop, expand on mobile
    const handleResize = () => {
      if (window.innerWidth < 700) setSidebarCollapsed(false);
      else setSidebarCollapsed(true);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="publicpage-layout">
      <nav className={`publicpage-sidemenu${sidebarCollapsed ? ' collapsed' : ''}`}>  
        {/* Toggle button only on desktop */}
        {window.innerWidth >= 700 && (
          <button
            className="sidebar-toggle-btn"
            type="button"
            onClick={() => setSidebarCollapsed((prev) => !prev)}
            style={{ marginBottom: '1.2rem', alignSelf: 'flex-end', fontSize: 18, padding: '4px 12px', borderRadius: 6, border: '1px solid #ccc', background: '#f5f5f5', cursor: 'pointer' }}
            aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {sidebarCollapsed ? <FaAngleDoubleRight /> : <FaAngleDoubleLeft />}
          </button>
        )}
        <NavLink to="/publicuser/publicpage/profile" className={({ isActive }) => isActive ? 'active' : ''} end>
          <span className="sidebar-icon"><FaUser /></span>
          <span className="sidebar-label">Profile</span>
        </NavLink>
        <NavLink to="/publicuser/publicpage/notifications" className={({ isActive }) => isActive ? 'active' : ''} end>
          <span className="sidebar-icon"><FaBell /></span>
          <span className="sidebar-label">Notifications</span>
        </NavLink>
        <NavLink to="/publicuser/publicpage/changepassword" className={({ isActive }) => isActive ? 'active' : ''} end>
          <span className="sidebar-icon">🔒</span>
          <span className="sidebar-label">Change Password</span>
        </NavLink>
        {/* Logout button directly below Change Password */}
        <button className="logout-btn" onClick={handleLogout}>
          <span className="sidebar-icon"><FaSignOutAlt /></span>
          <span className="sidebar-label">Logout</span>
        </button>
      </nav>
      <main className="publicpage-content">
        <Routes>
          <Route path="" element={<Navigate to="notifications" replace />} />
          {/* ...existing code... */}
          <Route path="notifications" element={<NotificationPanelContainer email={userEmail} />} />
          <Route path="profile" element={<ProfileUpdateForm />} />
          <Route path="changepassword" element={React.createElement(require('./ChangePassword').default)} />
        </Routes>
      </main>
    </div>
  );
};

export default PublicPage;
